export function addTimeLayer(map) {
  return this.control.addTo(map);
}
